import { RequestMethod, RequestPayloadType } from "types/enums";

import StoreRequestConfigRequest = App.Http.Requests.ConnectionCreator.StoreRequestConfigRequest;

export const transformRequestConfig = (
    requestConfig: App.Data.RequestConfigData | undefined
): StoreRequestConfigRequest => {
    if (!requestConfig) {
        return {
            id: null,
            name: "config",
            method: RequestMethod.Get,
            url: "",
            timeout_ms: 0,
            send_payload_as: RequestPayloadType.Json,
            empty_fields_behavior: null,
            headers: [],
            requestConnectionProperties: [],
            requestConnectionPropertiesUrl: [],
            requestConnectionPropertiesPathParam: [],
            responseHandlers: [],
        };
    }

    return {
        id: requestConfig.id ?? null,
        name: "config",
        method: requestConfig.method,
        url: requestConfig.url,
        timeout_ms: requestConfig.timeout_ms,
        send_payload_as: requestConfig.send_payload_as,
        empty_fields_behavior: requestConfig.empty_fields_behavior ?? null,
        requestConnectionPropertiesPathParam: [],
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        headers:
            requestConfig.headers?.map((header) => ({
                ...header,
                requestConnectionPropertyModify: header.requestConnectionPropertyModify ?? [],
            })) ?? [],

        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore - record type
        requestConnectionProperties:
            requestConfig.requestConnectionProperties?.map((property) => ({
                ...property,
                id: property.id || null,
                value: property.value || "",
                accessor: property.accessor || "",
                requestConnectionPropertyCombine: property.requestConnectionPropertyCombine ?? [],
                requestConnectionPropertyModify: property.requestConnectionPropertyModify ?? [],
            })) ?? [],

        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore - record type
        requestConnectionPropertiesUrl:
            requestConfig.requestConnectionPropertiesUrl?.map((property) => ({
                ...property,
                id: property.id || null,
                value: property.value || "",
                accessor: property.accessor || "",
                requestConnectionPropertyCombine: property.requestConnectionPropertyCombine ?? [],
                requestConnectionPropertyModify: property.requestConnectionPropertyModify ?? [],
            })) ?? [],

        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore - record type
        responseHandlers:
            requestConfig.responseHandlers?.map((handler, index) => ({
                ...handler,
                id: handler.id || null,
                order: handler.order ?? index,
                responseConnectionProperties:
                    handler.responseConnectionProperties?.map((property) => ({
                        ...property,
                        requestConnectionPropertyModify: property.requestConnectionPropertyModify ?? [],
                    })) ?? [],
                responseConnectionPropertiesCheck:
                    handler.responseConnectionPropertiesCheck?.map((property) => ({
                        ...property,
                        accessor: property.accessor || "-",
                        type: "basic",
                        value: property.value ?? "",
                        value2: property.value2 ?? "",
                    })) ?? [],
                stepConnection: Array.isArray(handler.stepConnection) ? handler.stepConnection : []
            })) ?? [],
    };
};
